import { useEffect } from "react";
import { App, Form, Input, Modal, Select } from "antd";
import {
  CategoryInterface,
  ContentTopic,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
} from "api";
import { getErrorMessage } from "components";
import { CONTENT_TOPIC_OPTIONS } from "./contentTopics";

interface CategoryFormInterface {
  // Absent = create mode.
  category?: CategoryInterface;
  onCancel: () => void;
}

interface CategoryFormValues {
  name: string;
  topic?: ContentTopic;
}

export const CategoryForm = ({ category, onCancel }: CategoryFormInterface) => {
  const [form] = Form.useForm<CategoryFormValues>();
  const { notification } = App.useApp();

  const [createCategory, createState] = useCreateCategoryMutation();
  const [updateCategory, updateState] = useUpdateCategoryMutation();

  const { isLoading, error, isSuccess } = category ? updateState : createState;

  useEffect(() => {
    if (error) {
      notification.error({ message: getErrorMessage(error) });
    }
  }, [error, notification]);

  useEffect(() => {
    if (isSuccess) {
      notification.success({
        message: category
          ? "Categoria a fost modificata"
          : "Categoria a fost adaugata",
      });
      onCancel();
    }
  }, [isSuccess, category, notification, onCancel]);

  const onOkClick = () => {
    const { name, topic } = form.getFieldsValue();
    // Select's allowClear yields undefined; the API needs an explicit null to
    // unbind the topic, since an omitted key leaves the binding untouched.
    const payload = { name, topic: topic ?? null };

    return category
      ? updateCategory({ id: category.id, ...payload })
      : createCategory(payload);
  };

  return (
    <Modal
      title={category ? "Modifica categorie" : "Adauga categorie"}
      okText={category ? "Salveaza" : "Creeaza"}
      onOk={onOkClick}
      okButtonProps={{ loading: isLoading }}
      onCancel={onCancel}
      cancelText="Inchide"
      open
    >
      <Form
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ width: "80%" }}
        initialValues={{
          name: category?.name,
          topic: category?.topic ?? undefined,
        }}
      >
        <Form.Item label="Nume" name="name">
          <Input />
        </Form.Item>

        <Form.Item
          label="Topic stiri"
          name="topic"
          extra="Leaga categoria de sursele de stiri ale botilor. Lasa gol daca nu vrei continut preluat automat in aceasta categorie. Un topic poate fi folosit de o singura categorie."
        >
          <Select
            options={CONTENT_TOPIC_OPTIONS}
            placeholder="Fara topic"
            allowClear
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
